import type { ReactNode } from 'react'
import { RightMenu } from './style'

interface HeaderRightProps {
  children: ReactNode
}

const HeaderRight = ({ children }: HeaderRightProps) => {
  return <RightMenu>{children}</RightMenu>
}

export default HeaderRight
